import { loadTemplate } from '@ag-grid-community/core/dist/cjs/utils/dom'
import { prettyFormatNumber } from '@helios/utils'
import { GenericTransaction, GenericTxSummary } from './generic-transaction'
import { TransactionsStatusBarBase } from './transactions-status-bar-base'
import { getAmountsByCurrency } from './utils'

const template = `
      <div class="hs-transactions-status-bar hs-transaction-amounts-status-bar hs-status-bar">
        <div class="value-container">
          <label >Amount:</label>
          <select class="form-control" id="amount-container">
          </select>
        </div>
      </div>
  `

export class TransactionsAmountStatusBarComp extends TransactionsStatusBarBase {
  private readonly onCopyBinding = this.onCopyClipboardEvent.bind(this)

  constructor() {
    super(template)

    document.addEventListener('copy', this.onCopyBinding)
  }

  destroy() {
    super.destroy()
    document.removeEventListener('copy', this.onCopyBinding)
  }

  onRowSelectionChanged = (selection: GenericTransaction[]) => {
    this.setEmpty(selection)
    const allAmounts = getAmountsByCurrency(selection)

    const options = Array.from(allAmounts.entries()).map(([currCode, amount]) =>
      loadTemplate(
        `<option>${prettyFormatNumber(amount, 4)} ${currCode}</option>`,
      ),
    )
    this.updateAmountOptions(options)
  }

  onSelectAllTransactions = (data: GenericTxSummary) => {
    if (data !== undefined) {
      const optionsHtml: HTMLElement[] = []
      const options = data.amountByCurrencyCode
      if (options !== undefined) {
        Object.entries(options).forEach(([currCode, amount]) => {
          optionsHtml.push(
            loadTemplate(
              `<option>${prettyFormatNumber(amount, 4)} ${currCode}</option>`,
            ),
          )
        })
      }

      this.updateAmountOptions(optionsHtml)
    }
  }

  private updateAmountOptions(optionsHtml: HTMLElement[]) {
    const unitsEl = this.eGui.querySelector(
      '#amount-container',
    ) as HTMLSelectElement
    if (unitsEl != null) {
      //An index has not been selected yet if 0 is the max, so default to 0.
      const previousSelectedIndex = Math.max(0, unitsEl.selectedIndex)

      //If optionsHtml.length - 1 is less than the previous selected index, then something was removed.
      const newSelectedIndex = Math.min(
        previousSelectedIndex,
        optionsHtml.length - 1,
      )

      unitsEl.innerHTML = ''
      optionsHtml.forEach(op => unitsEl.append(op))
      unitsEl.selectedIndex = newSelectedIndex
    }
  }

  private onCopyClipboardEvent(event: ClipboardEvent) {
    const focusedElement = document.activeElement
    if (focusedElement?.id === 'amount-container') {
      event.preventDefault()
      // Assuming here that `focusedElement` is a select HTML element
      const selectElement = focusedElement as HTMLSelectElement
      const selectedOptionValue = selectElement.value
      const matchValue = selectedOptionValue.match(/-?[\d,]+(\.\d+)?/)
      event.clipboardData?.setData(
        'text/plain',
        matchValue ? matchValue[0] : '',
      )
    }
  }
}
